import { FC, PropsWithChildren } from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';

import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { useModalsStore } from '@/widgets/modals/modals.store';

import { STYLES_PIN_BOTTOM } from '../styles';

type ModalContainerV2Props = PropsWithChildren & {
  title?: string;
  pinBottom?: boolean;
  className?: string;
  closable?: boolean;
};

export const ModalContainerV2: FC<ModalContainerV2Props> = ({
  title,
  pinBottom,
  className,
  children,
  closable,
}) => {
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();

  return (
    <Modal
      open={true}
      centered={isDesktop}
      footer={null}
      width={600}
      title={title ? <Title>{title}</Title> : undefined}
      onCancel={closable === true || closable === undefined ? modals.closeModal : undefined}
      style={pinBottom && !isDesktop ? STYLES_PIN_BOTTOM : {}}
      className={className}
      styles={{
        content: {
          maxHeight: 'calc(100vh - 160px)',
          overflow: 'auto',
        },
      }}
      closable={closable}
    >
      {children}
    </Modal>
  );
};

const Title = styled.span`
  font-family: 'Manrope';
  font-weight: 600;
  font-size: 16px;
`;
